export enum SavingState {
    notChanged = 'notChanged',
    notSaved = 'notSaved',
    saving = 'saving',
    saved = 'saved',
    error = 'error',
}
